import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  Form,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Col,
  FormGroup,
  Label,
  CardBody,
} from "reactstrap";
// core components
import AttendanceModel from "models/Attendance.modal";
import AttendanceMode from "models/Attendance.modal";
import { Link } from "react-router-dom";
import "./Calendar.css";
import classModal from "models/class.modal";
import { toast } from "lib/helper";
import moment from "moment";

const AttendanceSummary = ({ CycleId, ClassData }) => {
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [totalDuration, setTotalDuration] = useState("00");
  const [totalDurationMinutes, setTotalDurationMinutes] = useState(0);
  useEffect(() => {
    if (startTime && endTime) {
      const [startHours, startMinutes] = startTime.split(":").map(Number);
      const [endHours, endMinutes] = endTime.split(":").map(Number);

      let startTotalMinutes = startHours * 60 + startMinutes;
      let endTotalMinutes = endHours * 60 + endMinutes;

      // Handle case where end time is past midnight
      if (endTotalMinutes < startTotalMinutes) {
        endTotalMinutes += 24 * 60;
      }

      let durationMinutes = endTotalMinutes - startTotalMinutes;

      const hours = Math.floor(durationMinutes / 60);
      const minutes = durationMinutes % 60;

      const formattedDuration = `${String(hours).padStart(2, "0")}:${String(
        minutes
      ).padStart(2, "0")}`;

      setTotalDuration(formattedDuration);
      setTotalDurationMinutes(durationMinutes);
    } else {
      setTotalDuration("00:00");
      setTotalDurationMinutes(0);
    }
  }, [startTime, endTime]);
  const [totalMinutes, setTotalMinutes] = useState(0);

  useEffect(() => {
    if (startTime && endTime) {
      const [startHours, startMinutes] = startTime.split(":").map(Number);
      const [endHours, endMinutes] = endTime.split(":").map(Number);

      const startTotalMinutes = startHours * 60 + startMinutes;
      let endTotalMinutes = endHours * 60 + endMinutes;

      // Handle end time past midnight
      if (endTotalMinutes < startTotalMinutes) {
        endTotalMinutes += 24 * 60;
      }

      setTotalMinutes(endTotalMinutes - startTotalMinutes); // ✅ Total minutes only
    } else {
      setTotalMinutes(0);
    }
  }, [startTime, endTime]);
  console.log("data -------9", ClassData);
  const [updateStartTime, setUpdateStartTime] = useState("");
  const [updateEndTime, setUpdateEndTime] = useState("");
  const [totalUpdateDuration, setTotalUpdateDuration] = useState("");
  const [totalUpdateDurationMinutes, setTotalUpdateDurationMinutes] =
    useState(0);
  useEffect(() => {
    if (updateStartTime && updateEndTime) {
      const start = new Date(`1970-01-01T${updateStartTime}:00`);
      const end = new Date(`1970-01-01T${updateEndTime}:00`);
      const durationMinutes = Math.max(0, (end - start) / (1000 * 60));
      const hours = Math.floor(durationMinutes / 60);
      const minutes = Math.floor(durationMinutes % 60);
      const formattedDuration = `${String(hours).padStart(2, "0")}:${String(
        minutes
      ).padStart(2, "0")}`;
      setTotalUpdateDuration(formattedDuration);
      setTotalUpdateDurationMinutes(durationMinutes);
    } else {
      setTotalDuration("00:00");
      setTotalDurationMinutes(0);
    }
  }, [updateStartTime, updateEndTime]);

  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const [viewType, setViewType] = useState("list");
  const [attendance, setAttendance] = useState({});
  const [currentDate, setCurrentDate] = useState(new Date());

  // Function to get the name of the day
  const getDayName = (date) => {
    return date.toLocaleDateString("en-US", { weekday: "short" });
  };

  // Function to render all days in a month
  const renderMonth = () => {
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const startingDayOfWeek = firstDayOfMonth.getDay(); // 0 (Sunday) to 6 (Saturday)
    const daysInMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    ).getDate();
    const days = [];

    // Render empty cells for days before the first day of the month
    for (let i = 0; i < startingDayOfWeek; i++) {
      days.push(<div key={`empty-${i}`} className="empty-cell"></div>);
    }

    // Render cells for each day in the month
    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        i
      );
      days.push(renderDay(date));
    }

    return days;
  };

  // Function to generate weekday names
  const renderWeekdayNames = () => {
    const weekdayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return weekdayNames.map((day, index) => (
      <div key={index} className="weekday-name">
        {day}
      </div>
    ));
  };
  const [allAttendance, setSllAttendance] = useState([]);

  const params = useParams();
  const GetAllAttendance = async () => {
    // setIsLoading(true);
    // await AttendanceModel.GetAllAttendanceList(params?.id, CycleId)
    //   .then((result) => {
    //     setIsLoading(false);
    //     if (result) {
    //       setSllAttendance(result?.data?.data);
    //     }
    //   })
    //   .catch((error) => {
    //     // helper.sweetalert.toast(error.response?.data?.message, "warning");
    //   });
    const dummyAttendance = [
      {
        id: 1,
        date: "2023-10-01",
        start_time: "10:00 AM",
        end_time: "11:00 AM",
        student_id: 1,
        status: "Present",
      },
      {
        id: 2,
        date: "2023-10-02",
        start_time: "10:00 AM",
        end_time: "11:00 AM",
        student_id: 1,
        status: "Absent",
      },
      {
        id: 3,
        date: "2023-10-01",
        start_time: "10:00 AM",
        end_time: "11:00 AM",
        student_id: 2,
        status: "Present",
      },
    ];
    setSllAttendance(dummyAttendance);
    setIsLoading(false);
  };

  // Function to render a single day cell
  const renderDay = (date) => {
    if (!date) return null; // Handle invalid date

    // Create a new Date object using local time
    const localDate = new Date(
      date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
    );
    const formattedDate = localDate.getDate(); // Get the day part of the date

    // Get the month and year correctly based on local timezone
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed, so add 1 and pad
    const day = String(formattedDate).padStart(2, "0"); // Pad day to ensure it's always two digits

    const reversedDateKey = `${day}-${month}-${year}`; // Create 'DD-MM-YYYY' format

    // Find the corresponding attendance data for this date
    const attendanceData = allAttendance.find(
      (entry) => entry?.attendance_date === reversedDateKey
    );

    // Extract the attendanceStatus (class_type) if the date matches
    const attendanceStatus = attendanceData ? attendanceData.class_type : null;

    // Default to absent if no data is found
    let cellClassName = "day-cell absent"; // Default to absent

    // Apply class based on attendanceStatus
    if (attendanceStatus) {
      switch (attendanceStatus) {
        case "regular":
          cellClassName = "day-cell regular"; // Regular day
          break;
        case "leave":
          cellClassName = "day-cell leave"; // Leave day
          break;
        case "recovery":
          cellClassName = "day-cell recovery"; // Recovery day
          break;
        // Add more cases if needed
        default:
          break; // Leave as absent for any unrecognized statuses
      }
    }

    return (
      <div key={formattedDate} className={cellClassName}>
        <div className="day-number">{formattedDate}</div>
      </div>
    );
  };
  // Function to handle changing to the previous month
  const handlePrevMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
    );
  };

  // Function to handle changing to the next month
  const handleNextMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
    );
  };

  const [studentList, setStudentList] = useState(null);

  const getStudetListByClass = async () => {
    // await classModal
    //   .studentListByClass(params?.id)
    //   .then((result) => {
    //     console.log("student list -> ", result);
    //     if (result?.allstudents) {
    //       setStudentList(result?.allstudents);
    //     }
    //   })
    //   .catch((error) => {
    //     console.log("unable to get student list by class ", error);
    //   });
    const dummyStudents = [
      { id: 1, name: "Alice Student", roll_no: "001" },
      { id: 2, name: "Bob Student", roll_no: "002" },
    ];
    setStudentList(dummyStudents);
  };
  useEffect(() => {
    GetAllAttendance();
    getStudetListByClass();
  }, [location, params?.id, CycleId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const form = formData.get("date");

    const [year, mm, dd] = form.split("-");

    const formateddate = `${dd}-${mm}-${year}`;
    const starttime = formData.get("start_time"); // Ensure this is not null
    const endtime = formData.get("end_time");

    if (starttime && endtime) {
      formData.set("start_time", moment(starttime, "HH:mm").format("hh:mm A"));
      formData.set("end_time", moment(endtime, "HH:mm").format("hh:mm A"));
    } else {
      console.error("Invalid start_time or end_time");
    }
    formData.set("date", formateddate);

    await AttendanceModel.MarkAttendance(formData)
      .then((response) => {
        toast("Attendance marked successfully ");
        GetAllAttendance();
        toggle3();
      })
      .catch((error) => {
        console.log("Unable to mark attendance -> ", error);
      });
  };

  const [attendanceDetail, setAttendanceDetail] = useState(null);
  const GetAttendanceDetail = async (attendance) => {
    if (attendance) {
      setUpdateStartTime(attendance?.start_time);
      setUpdateEndTime(attendance?.end_time);
      toggle1();
      setAttendanceDetail(attendance);
    }
  };
  const [recoveryAttendanceId, setRecoveryAttendanceId] = useState(0);
  const [modal, setModal] = useState(false);
  const toggle = (recoverAtId = 0) => {
    setRecoveryAttendanceId(recoverAtId);
    setModal(!modal);
  };
  const [modal1, setModal1] = useState(false);
  const toggle1 = () => {
    setAttendanceDetail(null);
    setModal1(!modal1);
  };
  const [modal3, setModal3] = useState(false);
  const toggle3 = () => {
    setTotalDuration("");
    setTotalDurationMinutes(0);
    setModal3(!modal3);
  };

  const [recoveryBtnLoading, setRecoveryBtnLoading] = useState(false);
  const handleRecoverySubmit = async (e) => {
    e.preventDefault();
    if (recoveryAttendanceId !== 0) {
      setRecoveryBtnLoading(true);
      const formData = new FormData(e.target);
      await AttendanceModel.AddRecovery(recoveryAttendanceId, formData)
        .then((response) => {
          GetAllAttendance();
          toggle();
          setRecoveryBtnLoading(false);
        })
        .catch((error) => {
          console.log("error adding recovery attendance", error);
        });
    }
  };
  const [updateBtnLoading, setUpdateBtnLoading] = useState(false);
  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    if (attendanceDetail) {
      setUpdateBtnLoading(true);
      const formData = new FormData(e.target);
      await AttendanceModel.UpdateAttendance(attendanceDetail?.id, formData)
        .then((response) => {
          GetAllAttendance();
          toggle1();
          setUpdateBtnLoading(false);
        })
        .catch((error) => {
          console.log("error updating attendance", error);
        });
    }
  };
  const DeleteAttendence = async (id) => {
    AttendanceMode.Attendancedelete(id)
      .then((response) => {
        GetAllAttendance();
        helper.sweetalert.toast(response?.data?.message);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const tableRef = useRef(null);
  const downloadPDF = () => {
    const input = tableRef.current;

    if (!input) {
      console.error("Table element not found.");
      return;
    }

    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const width = pdf.internal.pageSize.getWidth();
        const height = (canvas.height * width) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, width, height);
        pdf.save("tutors_list.pdf");
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };

  return (
    <>
      <Container>
        {!isLoading && (
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between ">
                  <h3 className="mb-0">Attendance Summary</h3>
                </CardHeader>

                <div className="calendars ml-4" id="target-section">
                  <div className="tabs">
                    <Button
                      onClick={() => setViewType("list")}
                      // className={viewType === "list" ? "active d-none" : ""}
                    >
                      List View
                    </Button>
                    <Button
                      onClick={() => setViewType("grid")}
                      // className={viewType === "grid" ? "active" : "d-none"}
                    >
                      Grid View
                    </Button>

                    <Button style={{ float: "right" }} onClick={toggle3}>
                      Mark Attendance
                    </Button>
                    <Button
                      size="sm"
                      onClick={downloadPDF}
                      // style={{ width: "1x" }}
                      style={{
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                      }}
                    >
                      <i class="fa-solid fa-download"></i>
                    </Button>
                  </div>

                  {viewType === "list" ? (
                    <div ref={tableRef}>
                      <Table
                        className="align-items-center table-flush mt-3"
                        responsive
                      >
                        <thead className="thead-light">
                          <tr>
                            <th scope="col">SN.</th>

                            <th scope="col">Date(Days)</th>
                            <th scope="col">Tutor Name</th>
                            <th scope="col">Time in</th>
                            <th scope="col">Time out </th>
                            <th scope="col">Total Duration</th>
                            <th scope="col">extendTime</th>
                            <th scope="col">Attendance Type</th>
                            <th scope="col">Class Summary</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {allAttendance?.map((item, index) => {
                            const formatstarttime = () => {
                              if (!item?.start_time) return ""; // Handle empty or undefined time

                              const timeString = item?.start_time || ""; // Ensure start_time is a valid string
                              let [hours, minutes] = timeString.split(":");
                              hours = parseInt(hours);
                              let period = hours >= 12 ? "PM" : "AM";
                              hours = hours % 12 || 12; // Convert hour '0' to '12'
                              return `${hours}:${minutes} ${period}`;
                            };

                            const formatendtime = () => {
                              if (!item?.end_time) return ""; // Handle empty or undefined time

                              const timeString = item?.end_time || ""; // Ensure end_time is a valid string
                              let [hours, minutes] = timeString.split(":");
                              hours = parseInt(hours);
                              let period = hours >= 12 ? "PM" : "AM";
                              hours = hours % 12 || 12; // Convert hour '0' to '12'
                              return `${hours}:${minutes} ${period}`;
                            };
                            console.log("tryyyyyyy", item?.start_time);
                            return (
                              <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>{item?.date}</td>
                                <td>{item?.tutorData?.first_name}</td>
                                <td>{item?.start_time}</td>
                                <td>{item?.end_time}</td>

                                <td>{item?.total_time} Min</td>
                                <td>{`${item?.extendTime} Min`}</td>
                                <td>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <span style={{ display: "flex" }}>
                                      {item?.class_type}
                                    </span>
                                    <span
                                      style={{
                                        color: "#17a2b8",
                                        display: "flex",
                                      }}
                                    >{`(${
                                      item?.leaveBy == null
                                        ? "-----"
                                        : item?.leaveBy
                                    })`}</span>
                                  </div>
                                </td>
                                <td>
                                  {item?.remark?.map((remark, remarkindex) => {
                                    return (
                                      <div key={`remark${remarkindex}`}>
                                        <div>
                                          <b>{remark?.student_name}</b> :{" "}
                                          {remark?.topic_covered}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </td>
                                {/* <td>{formattedDate}</td> */}
                                <td
                                  className="p-0 pr-4"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <UncontrolledTooltip
                                    placement="top"
                                    target="eyeTooltip"
                                  >
                                    Add Recovery
                                  </UncontrolledTooltip>
                                  <p
                                    style={{
                                      margin: "0 5px",
                                      fontSize: "15px",
                                      color: "blue",
                                      marginTop: "10px",
                                      display: "inline-block",
                                      cursor: "pointer",
                                      borderRadius: "30%", // Optional: Make it a circle
                                    }}
                                    id="eyeTooltip"
                                    onClick={() => toggle(item?.id)}
                                  >
                                    <i class="fa-solid fa-plus"></i>
                                  </p>

                                  <UncontrolledTooltip
                                    placement="top"
                                    target="eyeTooltip1"
                                  >
                                    Edit
                                  </UncontrolledTooltip>
                                  <p
                                    style={{
                                      margin: "0 5px",
                                      fontSize: "15px",
                                      color: "blue",
                                      marginTop: "10px",
                                      display: "inline-block",
                                      cursor: "pointer",
                                      borderRadius: "30%", // Optional: Make it a circle
                                    }}
                                    id="eyeTooltip1"
                                    onClick={() => GetAttendanceDetail(item)}
                                  >
                                    <i className="fa-solid fa-pen-to-square"></i>
                                  </p>
                                  <p
                                    style={{
                                      margin: "0 5px",
                                      fontSize: "15px",
                                      color: "red",
                                      marginTop: "10px",
                                      display: "inline-block",
                                      cursor: "pointer",

                                      borderRadius: "30%", // Optional: Make it a circle
                                    }}
                                    onClick={() => {
                                      DeleteAttendence(item?.id);
                                      // setId(item?.id);
                                    }}
                                    id={`userTooltip-${index}`}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </p>
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`userTooltip-${index}`}
                                  >
                                    Delete
                                  </UncontrolledTooltip>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <div className="calendar-container mt-4 mb-4">
                      <div className="calendar">
                        <div className="calendar-header">
                          <div className="month-navigation">
                            <button onClick={handlePrevMonth}>&#8249;</button>
                            <h2>
                              {currentDate.toLocaleDateString("en-US", {
                                month: "long",
                                year: "numeric",
                              })}
                            </h2>
                            <button onClick={handleNextMonth}>&#8250;</button>
                          </div>
                        </div>
                        <div className="weekday-names">
                          {renderWeekdayNames()}
                        </div>
                        <div className="calendar-body">{renderMonth()}</div>

                        <div className="attendance-status">
                          <span className="status-box absent">Absent</span>
                          <span className="status-box present">Present</span>
                          <span className="status-box leave">Leave</span>
                          <span className="status-box recovery">Recovery</span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <CardFooter className="py-4">
                  {/* <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/messages?"
                  /> */}
                </CardFooter>
              </Card>
            </div>
          </Row>
        )}

        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>
            <h4>Add Recovery Time</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleRecoverySubmit}>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label for="exampleEmail"> Time duration</Label>
                    <Input
                      id="forType"
                      type="text"
                      placeholder="Enter duration (in minutes)"
                      name="recoveryMinutes"
                      disabled={recoveryBtnLoading}
                    ></Input>
                  </FormGroup>
                </Col>
              </Row>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggle}>
                  Cancel
                </Button>
                <Button
                  color="primary"
                  type="submit"
                  disabled={recoveryBtnLoading}
                  style={{ float: "right", marginLeft: "5%" }}
                >
                  {recoveryBtnLoading ? "Please Wait..." : "Save"}
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal1} toggle={toggle1}>
          <ModalHeader toggle={toggle1}>
            <h4>Attendance Edit ({attendanceDetail?.date})</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleUpdateSubmit}>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="start_time"> Time In</Label>
                    <Input
                      id="forType"
                      type="time"
                      placeholder="Enter Time In"
                      name="start_time"
                      value={updateStartTime}
                      onChange={(e) => setUpdateStartTime(e.target.value)}
                    ></Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="end_time"> Time Out</Label>
                    <Input
                      type="time"
                      placeholder="Enter Time Out"
                      name="end_time"
                      value={updateEndTime}
                      onChange={(e) => setUpdateEndTime(e.target.value)}
                    ></Input>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label for="total_time"> Total Duration </Label>
                    <Input
                      type="text"
                      value={totalUpdateDuration}
                      disabled
                    ></Input>
                    <input
                      type="hidden"
                      name="total_time"
                      value={totalUpdateDurationMinutes}
                    />
                  </FormGroup>
                </Col>
              </Row>
              {attendanceDetail?.remark?.map((student, studentIndex) => (
                <Row key={`student${studentIndex}`}>
                  <Col md={12}>
                    <FormGroup>
                      <input
                        type="hidden"
                        name={`remark[${studentIndex}][student_id]`}
                        value={student?.student_id}
                      />
                      <input
                        type="hidden"
                        name={`remark[${studentIndex}][student_name]`}
                        value={student?.student_name}
                      />
                      <Label for="exampleEmail">
                        <b>{student?.name}</b> Summary
                      </Label>
                      <Input
                        id="forType"
                        type="textarea"
                        placeholder="Remark"
                        defaultValue={student?.topic_covered}
                        name={`remark[${studentIndex}][topic_covered]`}
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
              ))}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggle1}>
                  Cancel
                </Button>

                <Button
                  color="primary"
                  type="submit"
                  style={{ float: "right", marginLeft: "5%" }}
                  disabled={updateBtnLoading}
                >
                  {updateBtnLoading ? "Please wait..." : "Update"}
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal3} toggle={toggle3}>
          <ModalHeader toggle={toggle3}>
            <h4>Attendance Add</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmit}>
              <input type="hidden" name="class_id" value={params?.id} />
              <input type="hidden" name="classcycle_id" value={CycleId} />
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail"> Attendance Date</Label>
                    <Input
                      id="forType"
                      type="date"
                      placeholder="Enter Time In"
                      name="date"
                    ></Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail"> Tutor Name</Label>
                    <Input
                      id="forType"
                      disabled
                      type="text"
                      placeholder="Enter Tutor Name"
                      name=""
                      defaultValue={`${ClassData?.tutorData?.first_name}${" "}${
                        ClassData?.tutorData?.last_name
                      }`}
                    ></Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail"> Time In</Label>
                    <Input
                      id="forType"
                      type="time"
                      placeholder="Enter Time In"
                      name="start_time"
                      value={startTime}
                      onChange={(e) => setStartTime(e.target.value)}
                    ></Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail"> Time Out</Label>
                    <Input
                      id="forType"
                      type="time"
                      placeholder="Enter Time Out"
                      name="end_time"
                      value={endTime}
                      onChange={(e) => setEndTime(e.target.value)}
                    ></Input>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label for="total_time"> Total Duration </Label>
                    <Input type="text" disabled value={totalMinutes}></Input>
                    <Input
                      type="hidden"
                      name="total_time"
                      value={totalMinutes}
                    ></Input>
                  </FormGroup>
                </Col>
              </Row>
              {studentList?.map((student, studentIndex) => (
                <Row key={`student${studentIndex}`}>
                  <Col md={12}>
                    <FormGroup>
                      <input
                        type="hidden"
                        name={`remark[${studentIndex}][student_id]`}
                        value={student?.id}
                      />
                      <input
                        type="hidden"
                        name={`remark[${studentIndex}][student_name]`}
                        value={student?.name}
                      />
                      <Label for="exampleEmail">
                        <b>{student?.name}</b> Summary
                      </Label>
                      <Input
                        id="forType"
                        type="textarea"
                        placeholder="Remark"
                        name={`remark[${studentIndex}][topic_covered]`}
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
              ))}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" type="button" onClick={toggle3}>
                  Cancel
                </Button>
                <Button
                  color="primary"
                  type="submit"
                  style={{ float: "right", marginLeft: "5%" }}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>
      </Container>
    </>
  );
};

export default AttendanceSummary;
